import React, { useEffect, useState } from "react";
import { Main, Wrapper } from "./styles";
import SideBar from "../SideBar";
import { useLocation } from "react-router-dom";
import Home from "../Home";
import TopBar from "CRM/components/TopBar";
import DB from "../DB";
import Customer from "../Customer";
import Status from "../Status";
import Path from "../Path";
import Branch from "../Branch";
import Platform from "../Platform";
import Setting from "../Setting";
import Board from "../Board";
import Employee from "../Employee";
import BranchManage from "../BranchManage";
import { LEVEL, useMyInfo } from "CRM/hooks/GetMyInfo";
import { SideBarTitle } from "../SideBar/styles";
import { TeamManage } from "../TeamManage";
import { useNotiInfo } from "../../hooks/GetNotiInfo";
import { MessageModal } from "../../components/Edit/MessageModal";
import { useMediaQuery } from "react-responsive";
import { useIsMobile } from "../../components/IsMobile";
import { Notice } from "../Notice";

export const CRM = () => {
	const isMobile = useIsMobile();
	const location = useLocation();
	const { pathname } = location;
	// const current = pathname.split('/admin')[1]
	const current = pathname.split("/admin")[1] || "";
	const { myInfo, level } = useMyInfo();
	const [view, setView] = useState(true);
	const [messageModal, setMessegeModal] = useState(false);

	const [menu, setMenu] = useState<any>([]);

	const { notiInfo, notiInfoMutate, messageSwitch, setMessageSwitch } = useNotiInfo();

	useEffect(() => {
		isMobile && setView(false);
	}, [isMobile]);

	useEffect(() => {
		let menu: { name: string; url: string }[] = [];
		if (level == LEVEL.MASTER || level == LEVEL.ADMIN) {
			menu = [
				{ name: "HOME", url: "" },
				{ name: "공지사항", url: "/notice" },
				{ name: "DB관리", url: "/db" },
				{ name: "거래고객관리", url: "/customer" },
				{ name: "페이다 입출금", url: "/branch" },
				{ name: "업무요청게시판", url: "/board" },
				{ name: "상태관리", url: "/status" },
				{ name: "방문경로관리", url: "/path" },
				{ name: "플랫폼관리", url: "/platform" },
				{ name: "직원관리", url: "/employee" },
				{ name: "지점관리", url: "/branchManage" },
				{ name: "팀관리", url: "/teamManage" },
				{ name: "설정", url: "/setting" },
			];
			if (!process.env.REACT_APP_URL?.includes("ccl")) menu = menu.filter((v) => v.url !== "/board");
		} else {
			if (level == LEVEL.LEADER) {
				menu = [
					{ name: "HOME", url: "" },
					{ name: "공지사항", url: "/notice" },
					{ name: "DB관리", url: "/db" },
					{ name: "거래고객관리", url: "/customer" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			} else if (level == LEVEL.USER) {
				menu = [
					{ name: "HOME", url: "" },
					{ name: "공지사항", url: "/notice" },
					{ name: "DB관리", url: "/db" },
					{ name: "거래고객관리", url: "/customer" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			} else if (level == LEVEL.BRANCHLEADER) {
				menu = [
					{ name: "공지사항", url: "/notice" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			} else {
				menu = [
					{ name: "공지사항", url: "/notice" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			}
		}

		if (!process.env.REACT_APP_URL?.includes("ccl") && [LEVEL.BRANCHLEADER, LEVEL.BRANCHUSER, LEVEL.ADMIN].includes(level)) {
			menu = menu.filter((v) => v.url !== "/board");
			if (!menu.some((v) => v.url == "")) menu.unshift({ name: "HOME", url: "" });
			if (!menu.some((v) => v.url == "/db")) menu.push({ name: "DB관리", url: "/db" });
			if (!menu.some((v) => v.url == "/customer")) menu.push({ name: "거래고객관리", url: "/customer" });
			if (!menu.some((v) => v.url == "/branch")) menu.push({ name: "페이다 입출금", url: "/branch" });
		}

		setMenu(menu);
	}, [level]);

	return (
		<Main>
			<SideBar
				current={current}
				view={view}
				setMessegeModal={setMessegeModal}
				messageSwitch={messageSwitch}
				setMessageSwitch={setMessageSwitch}
				notiInfo={notiInfo}
				setView={setView}
			/>
			<Wrapper>
				<TopBar view={view} setView={setView} />

				<div
					onClick={() => {
						isMobile && setView(false);
					}}
					style={{ paddingTop: isMobile ? 50 : 0 }}
				>
					{current === "" && (LEVEL.MASTER == level ? <Home /> : <Notice />)}
					{current === "/db" && <DB />}
					{current === "/customer" && <Customer />}
					{current === "/status" && LEVEL.MASTER == level && <Status />}
					{current === "/path" && LEVEL.MASTER == level && <Path />}
					{current === "/branch" && <Branch />}
					{current === "/platform" && LEVEL.MASTER == level && <Platform />}
					{current === "/board" && LEVEL.MASTER == level && <Board />}
					{current === "/employee" && LEVEL.MASTER == level && <Employee />}
					{current === "/branchManage" && LEVEL.MASTER == level && <BranchManage />}
					{current === "/teamManage" && LEVEL.MASTER == level && <TeamManage />}
					{current === "/setting" && LEVEL.MASTER == level && <Setting />}
					{current === "/notice" && <Notice />}

					{/* 수정 전 코드 */}
					{/*{menu.map((item: any, index: number) => {*/}
					{/*	if (current === item.url) {*/}
					{/*		if (item.name === 'HOME') {*/}
					{/*			return <Home key={index} />*/}
					{/*		} else if (item.name === 'DB관리') {*/}
					{/*			return <DB key={index} />*/}
					{/*		} else if (item.name === '거래고객관리') {*/}
					{/*			return <Customer key={index} />*/}
					{/*		} else if (item.name === '상태관리') {*/}
					{/*			return <Status key={index} />*/}
					{/*		} else if (item.name === '방문경로관리') {*/}
					{/*			return <Path key={index} />*/}
					{/*		} else if (item.name === '페이다 입출금') {*/}
					{/*			return <Branch key={index} />*/}
					{/*		} else if (item.name === '플랫폼관리') {*/}
					{/*			return <Platform key={index} />*/}
					{/*		} else if (item.name === '업무요청게시판') {*/}
					{/*			return <Board key={index} />*/}
					{/*		} else if (item.name === '직원관리') {*/}
					{/*			return <Employee key={index} />*/}
					{/*		} else if (item.name === '지점관리') {*/}
					{/*			return <BranchManage key={index} />*/}
					{/*		} else if (item.name === '팀관리') {*/}
					{/*			return <TeamManage key={index} />*/}
					{/*		} else if (item.name === '설정') {*/}
					{/*			return <Setting key={index} />*/}
					{/*		} else {*/}
					{/*      return <div key={index}>404</div>*/}
					{/*    }*/}
					{/*	}*/}
					{/*})}*/}

					{menu.filter((item: any) => item.url === current).length === 0 && <SideBarTitle>⛔접근권한이 없습니다.</SideBarTitle>}
				</div>

				{messageModal && <MessageModal setMessegeModal={setMessegeModal} notiInfoMutate={notiInfoMutate} />}

				{/* 수정 전 코드 */}
				{/*{ menu.filter((item: any) => item.url === current).length === 0 ? <SideBarTitle>⛔접근권한이 없습니다.</SideBarTitle> : null }*/}
			</Wrapper>
		</Main>
	);
};

export default React.memo(CRM);
